<template>
  <v-list>
    <v-subheader
      style="background-color: #DDE7F8;font-weight: bold;font-size: 16px;"
    >
      <v-row>
        <v-col>
          {{ factor?.name }}
          ({{ factor?.ratio }}%)
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          {{ score.toFixed(2) }} / {{ max_score.toFixed(2) }}
        </v-col>
      </v-row>
    </v-subheader>
    <slot />
    <!-- questions -->
    <RiskAssessmentQuestion
      v-for="(question) in factor?.questions"
      :key="question.id"
      :question="question"
      @onScoreUpdate="onQuestionScoreUpdate"
    />
  </v-list>
</template>

<script>
import RiskAssessmentQuestion from './RiskAssessmentQuestion.vue'

export default {
  components: {
    RiskAssessmentQuestion
  },
  props: {
    factor: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      questionScores: {},
      score: 0,
      max_score: 0,
      min_score: 0,
      completed: false
    }
  },
  // computed: {
  //   score () {
  //     return Object.values(this.questionScores).reduce((acc, score) => acc + score.score, 0)
  //   }
  // },
  methods: {
    onQuestionScoreUpdate ({ question, answer, score_scaled, max_score_scaled, min_score_scaled }) {
      this.questionScores[question.id] = {
        answer,
        score: score_scaled,
        max: max_score_scaled,
        min: min_score_scaled
      }
      this.updateScore()
    },
    updateScore () {
      const ratio = this.factor.ratio / 100
      this.score = Object.values(this.questionScores).reduce((acc, score) => acc + score.score, 0) * ratio
      this.max_score = Object.values(this.questionScores).reduce((acc, score) => acc + score.max, 0) * ratio
      this.min_score = Object.values(this.questionScores).reduce((acc, score) => acc + score.min, 0) * ratio
      this.completed = Object.values(this.questionScores).every(question => question.answer !== null)
      this.$emit('onFactorScoreUpdate', {
        factor: this.factor,
        completed: this.completed,
        score_scaled: this.score,
        min_score_scaled: this.min_score,
        max_score_scaled: this.max_score,
        question_scores: this.questionScores
      })
    }
  }
}
</script>
